import { MapSearchInput } from '../../../shared/utils/queryUtils'

export const invoiceTableFields: MapSearchInput['path'] = {
    date: ['createdAt', 'invoiceDate', 'dueDate'],
    name: ['id', 'invoiceNumber', 'debtorName', 'debtorIdentifier.value'],
    number: ['totalAmountIncludingTaxes']
}
